import { updateLinksAttributes } from '../../utils/handleAttributes';

export default function seoWidget() {
  const widgetName = 'seoWidget';
  const widgetOpts = seoWidgetOpts;
  const $widget = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    textOverImage: false,
    itemsPerPanel: 1,
    maxItemsVisible: 1,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createCustomseoWidget(data.items);
      } else {
        $widget.remove();
      }
    },
  });

  function createCustomseoWidget(widgetData) {
    const $seo = $widget.find('.card-widget-item');
    const { Title, Description, URL } = widgetData[0];

    $seo.replaceWith(`
      <div class="container-abstract top-abstract"><span></span></div>
        <h1 class="seo-title">${Title}</h1>
        <div class="seo-description">${Description}</div>
          ${URL == null ? '' : `<a href="${URL}" class="button" ${updateLinksAttributes(URL, Title)}>Learn More</a>`}
      <div class="container-abstract bottom-abstract"><span></span></div>
    `);
  }
}
